import { render } from "./Controller.vue?vue&type=template&id=1af4d9d4&scoped=true"
import script from "./Controller.vue?vue&type=script&lang=js"
export * from "./Controller.vue?vue&type=script&lang=js"

import "./Controller.vue?vue&type=style&index=0&id=1af4d9d4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af4d9d4"]])

export default __exports__